import { RootState } from "@/app/stores"
import { getApiKey, getIntegration, IApiKey, IIntegration } from "@/shared/api/settings"
import { ErrorType } from "@/shared/types"
import { createAsyncThunk } from "@reduxjs/toolkit"
import { AxiosError } from "axios"

export const fetchApiKey = createAsyncThunk<
    IApiKey,
    null,
    { state: RootState }
>(`settings/fetchApiKey`, async (_, thunkAPI) => {
    try {
        const data = await getApiKey()
        return data.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})

export const fetchUserIntegration = createAsyncThunk<
    IIntegration,
    null,
    { state: RootState }
> (`settings/fetchUserIntegration`, async (_, thunkAPI) => {
    try {
        const data = await getIntegration()
        return data.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})